/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createSetDiscountPermissionsResponseFromDiscriminatorValue, serializeSetDiscountPermissionsRequest, serializeSetDiscountPermissionsResponse, type ErrorResponse, type InternalErrorResponse, type SetDiscountPermissionsRequest, type SetDiscountPermissionsResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/salesreps/discountpermissions
 */
export interface DiscountpermissionsRequestBuilder extends BaseRequestBuilder<DiscountpermissionsRequestBuilder> {
    /**
     * Sets whether this rep may apply an order-level discount and whether they may apply line-item discounts in the sales app. Each kind is inherit (use the organization's default from cart pricing settings), allow or deny; allow and deny override the default for this rep either way. Both kinds are required — this replaces the rep's settings, it does not patch them. Only applying a discount is gated: carts and orders that already carry one keep it. The rep's device picks the change up on its next sync.
     * @param body Sets one Sales Representative's own discount permissions for the sales app, laid over theorganization's defaults from cart pricing settings. A full replace: both kinds are required.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SetDiscountPermissionsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: SetDiscountPermissionsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SetDiscountPermissionsResponse | undefined>;
    /**
     * Sets whether this rep may apply an order-level discount and whether they may apply line-item discounts in the sales app. Each kind is inherit (use the organization's default from cart pricing settings), allow or deny; allow and deny override the default for this rep either way. Both kinds are required — this replaces the rep's settings, it does not patch them. Only applying a discount is gated: carts and orders that already carry one keep it. The rep's device picks the change up on its next sync.
     * @param body Sets one Sales Representative's own discount permissions for the sales app, laid over theorganization's defaults from cart pricing settings. A full replace: both kinds are required.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SetDiscountPermissionsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DiscountpermissionsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/salesreps/discountpermissions";
/**
 * Metadata for all the requests in the request builder.
 */
export const DiscountpermissionsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DiscountpermissionsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSetDiscountPermissionsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSetDiscountPermissionsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
